var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-grid grid-3 grid-md-1 mb-24"},_vm._l((_vm.documents),function(doc,index){return _c('div',{key:index,staticClass:"container-grid__item"},[_c('ContentDocumentCard',{attrs:{"title":doc.title,"link":doc.link}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }